import React from 'react'
import { Grid } from '@material-ui/core'
import LoadingErrorIcon from '../../../app/images/loadingError.svg'
import {
  MidsizedGridContainerWithWhiteBackground,
  LargeFontParagraph,
  VerticallyCenteredFlexboxWrapper,
  ErrorMessageIconJSS
} from '../../../theme/Global/errorStyle'
import SVGIconRenderer from '../svgIcon'
import AccountContact from '../AccountContact/AccountContact'

export default (props) => {
  const error = props.error
  console.error('Reached manual error boundary: ', error)
  return (
    <div data-testid="default-error-boundary-message">
      <MidsizedGridContainerWithWhiteBackground container>
        <VerticallyCenteredFlexboxWrapper item xs={3}>
          <SVGIconRenderer {...{ center: true, file: LoadingErrorIcon, style: ErrorMessageIconJSS }} />
        </VerticallyCenteredFlexboxWrapper>
        <Grid item xs={9}>
          <LargeFontParagraph>
            Sorry we&apos;re having some trouble loading the page and are working to resolve it. Please try refreshing the page or contact your Account Manager for help.
          </LargeFontParagraph>
        </Grid>
      </MidsizedGridContainerWithWhiteBackground>
      <Grid
        container
        direction="row"
        justify="flex-end"
        alignItems="center"
      >
        <Grid item xs={4}>
          <AccountContact />
        </Grid>
      </Grid>
    </div>
  )
}
